import VectorTileLayer from '@arcgis/core/layers/VectorTileLayer';

/**
 * Create and return an instance of the vector tile layer to be added to the map.
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-VectorTileLayer.html
 * @param {String} url - GIS cached-basemap service url
 */
export const createVectorTileLayer = async ({ url, ...props }) =>
  await handleVectorTileLayer({ url, ...props });

async function handleVectorTileLayer({ url, ...props }) {
  const vectorTileLayer = new VectorTileLayer({
    ...props,
    url,
  });

  // Layer must be loaded so that properties such as `sublayers` can be queried.
  await vectorTileLayer.load();

  return vectorTileLayer;
}
